import { Component } from 'react'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null, info: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    this.setState({ info })
    try { console.error('ErrorBoundary caught:', error, info) } catch {}
    try {
      const u = JSON.parse(localStorage.getItem('user') || 'null')
      fetch('/api/log-frontend-error', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: error?.name,
          message: error?.message || String(error),
          stack: (error?.stack || '').split('\n').slice(0, 20).join('\n'),
          componentStack: (info?.componentStack || '').split('\n').slice(0, 20).join('\n'),
          path: window.location.pathname + window.location.search,
          user: u?.username || null,
          context: 'ErrorBoundary',
        }),
      }).catch(() => {})
    } catch {}
  }

  reset = () => this.setState({ error: null, info: null })

  render() {
    if (!this.state.error) return this.props.children
    const e = this.state.error
    const stack = (e?.stack || '').split('\n').slice(0, 8).join('\n')
    const compStack = (this.state.info?.componentStack || '').split('\n').slice(0, 8).join('\n')
    return (
      <div className="min-h-screen p-6 bg-red-50 text-gray-800 flex items-start justify-center">
        <div className="max-w-3xl w-full bg-white rounded-xl shadow-lg border border-red-200 p-5">
          <div className="text-red-600 font-semibold text-base mb-1">Bir hata olustu</div>
          <div className="text-xs text-gray-500 mb-3">Sayfa cokmedi — asagidaki bilgiyle Akan'a iletilebilir.</div>
          <div className="bg-red-100 border border-red-200 rounded p-2 text-[12px] font-mono text-red-700 mb-2 break-words">
            {e?.name ? `${e.name}: ` : ''}{e?.message || String(e)}
          </div>
          {stack && (
            <details open className="mb-2">
              <summary className="text-[11px] text-gray-500 cursor-pointer">Stack</summary>
              <pre className="text-[10px] bg-gray-50 border rounded p-2 overflow-auto max-h-48 whitespace-pre-wrap">{stack}</pre>
            </details>
          )}
          {compStack && (
            <details className="mb-3">
              <summary className="text-[11px] text-gray-500 cursor-pointer">Component stack</summary>
              <pre className="text-[10px] bg-gray-50 border rounded p-2 overflow-auto max-h-48 whitespace-pre-wrap">{compStack}</pre>
            </details>
          )}
          <div className="flex gap-2">
            <button onClick={this.reset} className="text-xs bg-primary-600 text-white px-3 py-1.5 rounded hover:bg-primary-700">
              Tekrar Dene
            </button>
            <button onClick={() => { window.location.href = '/' }} className="text-xs bg-gray-100 text-gray-700 px-3 py-1.5 rounded hover:bg-gray-200">
              Ana Sayfa
            </button>
            <button onClick={() => window.location.reload()} className="text-xs bg-gray-100 text-gray-700 px-3 py-1.5 rounded hover:bg-gray-200">
              Sayfayi Yenile
            </button>
          </div>
        </div>
      </div>
    )
  }
}
